import { combineReducers } from 'redux';

import loading from 'modules/global/reducers/generic.loading';
import loadingArraySlice from 'modules/global/reducers/loadingArraySlice';
import * as types from 'modules/releases/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *  open: boolean,
 *  loading: {
 *    create: boolean,
 *    update: boolean,
 *    fetch: string[],
 *  },
 *  releaseId: string,
 * }} ReleaseUIModalCreationReducer
 */

const GENERIC_SLICE_CONFIG = {
  global: {
    selectId: entity => entity?.id ?? entity?.releaseId ?? entity,
  },
};

export default combineReducers({
  open: createReducer(false, {
    [LOCATION_CHANGE]: () => false,
    [types.OPEN_CREATION_MODAL]: () => true,
    [types.CLOSE_CREATION_MODAL]: () => false,
    [types.CREATE_RELEASE_SUCCESS]: () => false,
    [types.UPDATE_RELEASE_SUCCESS]: () => false,
  }),
  loading: combineReducers({
    create: loading(types.CREATE_RELEASE),
    update: loading(types.UPDATE_RELEASE),
    fetch: loadingArraySlice(types.FETCH_RELEASE_BY_ID, GENERIC_SLICE_CONFIG),
  }),
  releaseId: createReducer(null, {
    [types.OPEN_CREATION_MODAL]: (_, { payload }) => payload?.releaseId || null,
    [types.CLOSE_CREATION_MODAL]: () => null,
  }),
});
